import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'antd';
import { get } from 'lodash';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';

import { processTransaction, cancelTransaction } from '../../eventActions';
import { TICKETS_SALE_WIZARD_DETAILS, TICKETS_SALE_WIZARD_SURVEY } from '../../eventUtils';

import PaymentForm from '../../../../../donation/components/CreatePaymentForm';
import { surveyAttemptAction } from "../../../../../donation/components/SurveyAttemptAction"

const mapStateToProps = state => ({
  information: get(state, 'Event.purchaseInformation'),
  //target: get(state, 'campaign.campaign'),
  platformId: get(state, 'platform.platform.id'),
  platform: get(state, 'platform.platform'),
  locale: get(state, 'session.language'),
  isTransactionInProgress: get(state, 'ui.isTransactionInProgress'),
  countries: get(state, 'geo.countries', []),
  billing: get(state, 'organization.organization.billing'),
  back_survey: TICKETS_SALE_WIZARD_SURVEY,
  back_information: TICKETS_SALE_WIZARD_DETAILS,
  surveySubmitData: state.surveyAttempt.surveySubmitData,
  surveyId:state.donation.surveyId
});

const mapDispatchToProps = dispatch => bindActionCreators({
  cancelTransaction,
  processTransaction,
  surveyAttemptAction,
}, dispatch);


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withGoogleReCaptcha,
  Form.create()
)(PaymentForm);
